/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";
import { taxrateauthority } from './taxrateauthority';

export class taxrate extends IceEntity {
  tax_rate_key: string = "";
  rate_description: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  AUTHS: taxrateauthority[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "TAX_RATE";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "AUTHS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "AUTHS") return "TAX_AUTHORITY";

    return null;
  }
}
